import { withStyles } from "@material-ui/core";
import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUrlHelp } from "../../Store/Actions/ComunicadorActions";

const styles = theme => ({
    anotherLine: {
        backgroundColor: theme.palette.type === "dark" ? "#303030" : "#D4D4D4"
    }
});

let preload = false;

const Help = (props) => {
    const { data = null, removeAppMessage, setOpenMessage, changeContentPainel } = props;
    const dispatch = useDispatch();

    useEffect(() => {
        if (!_.isUndefined(data) && !_.isNull(data) && _.isUndefined(data.url) && !preload) {
            preload = true;
            dispatch(getUrlHelp(data.conteudo));
        }

        if (!_.isUndefined(data) && !_.isNull(data) && !_.isUndefined(data.url) && preload) {
            preload = false;
            removeAppMessage(data.idmensagem);
            setOpenMessage();
            changeContentPainel(
                <iframe
                    id={"iframe_" + data.idmensagem}
                    src={data.url}
                    width={"100%"}
                    height={"95%"}
                ></iframe>
            );
        }
    }, [data, preload]);

    return (
        <React.Fragment>
        </React.Fragment >
    );
};

export default withStyles(styles, { withTheme: true })(Help);